import {
  TREBLE_CLEF_PATH,
  BASS_CLEF_PATH,
  ALTO_CLEF_PATH
} from "./clefPaths";
import {
  TIME_SIG_PATHS
} from "./timesigPaths";

const STAFF_TOP = 40;
const LINE_GAP = 10;
const CLEF_SCALE = 0.038;
const TIME_SIG_SCALE = 0.038;
const TIME_SIG_GAP = 10; // vertical separation between top & bottom
const TIME_SIG_OFFSET_X = 3;  // distance right of clef
export const CLEF_MARGIN_LEFT = 35;
export const CLEF_WIDTH = 60; // reserved horizontal space
const clefX = CLEF_MARGIN_LEFT + CLEF_WIDTH / 2;

export function renderStaffLines(
  width,
  staffTop = STAFF_TOP   // backward compatible
) {
  return (
    <g>
      {Array.from({ length: 5 }).map((_, i) => (
        <line
          key={i}
          x1={50}
          x2={width}
          y1={staffTop + i * LINE_GAP}
          y2={staffTop + i * LINE_GAP}
          stroke="#000"
        />
      ))}
    </g>
  );
}

export function renderTimeSignature(
  timeSig,
  staffTop = STAFF_TOP,
  cLeft = 0
) {
  if (!timeSig) return null;

  const tTop = timeSig.split('/')[0];
  const tBot = timeSig.split('/')[1];

  const topPath = TIME_SIG_PATHS[tTop];
  const bottomPath = TIME_SIG_PATHS[tBot];
  if (!topPath || !bottomPath) return null;

  const centerY = staffTop + 2 * LINE_GAP + 10;

  const x =
    CLEF_MARGIN_LEFT +
    CLEF_WIDTH +
    TIME_SIG_OFFSET_X +
    cLeft;
  
  const adds = {
    1: 0,
    2: 0,
    3: 1,
    4: 0,
    5: 0,
    6: 0,
    7: 0,
    8: 0,
    9: 0
  };

  return (
    <g fill="#000">
      {/* TOP NUMBER */}
      <g
        transform={`
          translate(${x + adds[tTop]}, ${centerY - TIME_SIG_GAP})
          scale(${TIME_SIG_SCALE}, -${TIME_SIG_SCALE})
          translate(-150, 0)
        `}
      >
        <path d={topPath} />
      </g>

      {/* BOTTOM NUMBER */}
      <g
        transform={`
          translate(${x}, ${centerY + TIME_SIG_GAP})
          scale(${TIME_SIG_SCALE}, -${TIME_SIG_SCALE})
          translate(-150, 0)
        `}
      >
        <path d={bottomPath} />
      </g>
    </g>
  );
}

export function renderClef(
  clef,
  staffTop = STAFF_TOP,   // default keeps single-staff widgets working
  cLeft = 0,
) {
  let path;
  let anchorY;

  if (clef === "treble") {
    path = TREBLE_CLEF_PATH;
    anchorY = staffTop + 3 * LINE_GAP; // G line
  } else if (clef === "bass") {
    path = BASS_CLEF_PATH;
    anchorY = staffTop + LINE_GAP; // F line
  } else if (clef === "alto") {
    path = ALTO_CLEF_PATH;
    anchorY = staffTop + 2 * LINE_GAP; // middle C
  } else {
    return null;
  }

  return (
    <g
      transform={`
        translate(${CLEF_MARGIN_LEFT + CLEF_WIDTH / 2 + cLeft}, ${anchorY})
        scale(${CLEF_SCALE}, -${CLEF_SCALE})
        translate(-200, 0)
      `}
      fill="black"
    >
      <path d={path} />
    </g>
  );
}


